import { ProgramEngagementModel, TaskStatusReason } from '@cibo/core'
import { groupBy, pluck, prop } from 'ramda'
import { useProgramEngagement } from '../../../../queries'
import { ConfirmDeleteEngagementDialog } from './ConfirmDeleteEngagementDialog'
import { ConfirmIneligibleFieldsDialog } from './ConfirmIneligibleFieldsDialog'
import { ConfirmIneligibleUserDialog } from './ConfirmIneligibleUserDialog'

export type ConfirmIneligibleDialogProps = {
  engagementId?: string
  ineligibleReasons?: TaskStatusReason[]
  onClose(): void
  onConfirm(updatedEnagement?: ProgramEngagementModel): void
  open: boolean
}

export const ConfirmIneligibleDialog = ({
  ineligibleReasons,
  ...passProps
}: ConfirmIneligibleDialogProps) => {
  const engagement = useProgramEngagement({ id: passProps.engagementId })
  if (!ineligibleReasons?.length) return null

  const reasons = groupBy(prop('dataType'), ineligibleReasons)
  const resourceIds = (reasons?.field && pluck('id', reasons?.field)) || []

  if (resourceIds?.length === engagement.data?.fieldCounts?.total) {
    return <ConfirmDeleteEngagementDialog {...passProps} reasons={reasons.field} />
  }

  if (reasons.user) {
    return (
      <ConfirmIneligibleUserDialog
        {...passProps}
        onConfirm={() => !!engagement.data && passProps.onConfirm(engagement.data)}
        reasons={reasons.user}
      />
    )
  }

  if (reasons.field) {
    return <ConfirmIneligibleFieldsDialog {...passProps} reasons={reasons.field} />
  }

  // @todo: handle ineligible workflow details
  return null
}
